// LIBRERIE/IMPORTS
import React from "react";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetPropertiesVetrina, Immobile as VetrinaProperty } from "../../hooks/useGetPropertiesVetrina";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../Loaders/LoadingIndicator";

// CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Vetrina1: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { properties, loading, error } = useGetPropertiesVetrina(AGENCY_ID, { vetrina: 1 });

  // ---- Gestione Stati Iniziali ----
  if (loading) return <LoadingIndicator />;

  if (error) {
    console.error("Errore caricamento Vetrina:", error);
    return <div className="alert alert-warning">{t('common.loadingError', 'Errore caricamento dati.')}</div>;
  }

  if (!properties || properties.length === 0) {
    return <div className="text-center p-5">{t('propertyList.notFound.title')}</div>;
  }
  
  const sliderSettings = {
    dots: false,
    infinite: properties.length > 1,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover: true,
  };

  const fallbackImagePath = "/assets/images/no_image_big.png"; 

  // ---- FUNZIONE PER TRONCARE IL TESTO ----
  const truncateText = (text: string, maxLength: number) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, text.lastIndexOf(' ', maxLength)) + '...';
  };

  return (
    <section className="vetrina-slider-wrapper">
      <Slider {...sliderSettings}>
        {(properties as VetrinaProperty[]).map((immobile) => {
          const currentLangDescription = immobile.descriptions.find(
            (d) => d.langId === i18n.language
          );

          const descriptionToShow = currentLangDescription || immobile.descriptions[0];

          const shortDescription = truncateText(
            descriptionToShow ? descriptionToShow.text : t('common.descriptionNotAvailable', 'Descrizione non disponibile'),
            150
          );

          const propertyUrl = `/immobile/${immobile.id}`;
          const locationName = immobile.addressDetails.comuneName ?? t('common.locationUnknown', 'Località sconosciuta');
          const propertyTitle = `${immobile.tipologyDetails.name} - ${locationName} (${immobile.addressDetails.provinciaSigla})`;
          const linkTitle = t('property.detailsTitlePattern', { propertyName: propertyTitle });
          const imageUrl = immobile.mainImage || fallbackImagePath;

          return (
            <div key={immobile.id}>
              <div className="slider-slide">
                <img src={imageUrl} alt={propertyTitle} />
                <div className="slide-content">
                  <div className="slide-text">
                    <h3>{propertyTitle}</h3>
                    <p>{shortDescription}</p>
                    <Link to={propertyUrl} title={linkTitle} className="slide-details-link">
                      {t('common.details', 'Dettagli')} →
                    </Link>
                  </div>
                  <div className="slide-price">
                    {immobile.priceDetails.reservedNegotation
                      ? t('property.priceReserved', 'Tratt. Riservata')
                      : `€ ${new Intl.NumberFormat('it-IT').format(immobile.priceDetails.price)}`
                    }
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </section>
  );
};

export default Vetrina1;